import styled from '@emotion/styled';
import Fa from 'components/fa';

export default styled(Fa)`
  position: absolute;
  cursor: pointer;
  top: 10px;
  right: 10px;
  color: white;
  background: red;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  text-align: center;
  line-height: 19px;
  font-size: 15px;
`;
